import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../modal/modal.component';

/**
 * Wraps app-modal with a form container and optional error alert.
 * Use for create/edit modals that share the same structure: title, loading, submit/close, single error message, form body.
 */
@Component({
  selector: 'app-form-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, ModalComponent],
  templateUrl: './form-modal.component.html',
  styleUrl: './form-modal.component.scss',
})
export class FormModalComponent {
  title = input.required<string>();
  subtitle = input<string>();
  submitText = input('SUBMIT');
  closeText = input('CLOSE');
  loading = input(false);
  /** Form group that wraps the projected form fields. */
  formGroup = input.required<FormGroup>();
  /** Optional i18n key for a single error message (e.g. save failed). Shown as alert when set. */
  errorMessage = input<string | null>(null);

  submitClicked = output<void>();
}
